import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import heart from "./assets/heart.png";
import inlove from "./assets/inlove.png";

const FlamesGame = () => {
  const [myName, setMyName] = useState("");
  const [yourName, setYourName] = useState("");
  const [result, setResult] = useState("");
  const navigate = useNavigate();
  const flamesElimination = (count) => {
    let flames = ["F", "L", "A", "M", "E", "S"]; 
    let index = 0; // Start index

    while (flames.length > 1) {
      index = (index + count - 1) % flames.length; // Circular index calculation
      flames.splice(index, 1); // Remove letter
    }

    return flames[0]; // Return last remaining letter
  };

  const findMismatchedKeys = (arr1, arr2) => {
    console.log(arr1,arr2,'findMismatchedKeys' )
    const obj1 = Object.fromEntries(arr1);
    const obj2 = Object.fromEntries(arr2);
    let mismatchKeys = [];

    const allKeys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);

    allKeys.forEach((key) => {
    
      const count1 = obj1[key] || 0;
        const count2 = obj2[key] || 0;
        const diff = Math.abs(count1 - count2);
        for (let i = 0; i < diff; i++) {
            mismatchKeys.push(key);
        }
    });

    return mismatchKeys.length;
  };

  const countCharacters = (str) => {
    const count = {};
    for (let char of str) {
      count[char] = (count[char] || 0) + 1;
    }
    return Object.entries(count);
  };

  const handleFlames = () => {
    if (myName.trim() === "" || yourName.trim() === "") {
      alert("Please enter both names.");
      return;
    }

    let remSpcMyName = myName.replace(/\s/g,'')
    let remSpcYourName = yourName.replace(/\s/g,'')
    console.log(myName,"MYNAME",remSpcMyName,remSpcYourName)
    let countMyName = countCharacters(remSpcMyName.toLowerCase());
    let countYourName = countCharacters(remSpcYourName.toLowerCase());

    let count = findMismatchedKeys(countMyName, countYourName);
    let flamesResult = flamesElimination(count);
    setResult(flamesResult);
  };

  console.log(result,'result')
  const redirect = (result) => {
    navigate('/relationship', {state: {result}})
  };

  return (
    <div
      className="flamesGame"
      style={{ padding: "20px", fontFamily: "Arial", textAlign: "center" }}
    >
      <h2 className="flamesHeader2">FLAMES GAME</h2>
      <div className="inputBox">
        <div className="nameInput">
          <img src={heart} className="heartImg" alt="heart" />
          <input
            type="text"
            placeholder="Enter your name"
            value={myName}
            onChange={(e) => setMyName(e.target.value)}
            className="myNameInput"
          />
        </div>
        <div className='nameInput'>
          <img src={inlove} className="heartImg" alt="inlove" />
          <input
            type="text"
            placeholder="Enter partner's name"
            value={yourName}
            onChange={(e) => setYourName(e.target.value)}
            className="myNameInput"
          />
        </div>
      </div>
      <br />
      <button
        onClick={handleFlames}
        style={{ padding: "8px 15px", marginTop: "10px" }}
        className="button"
      >
        Find Relationship
      </button>
      {result && <p>{redirect(result)}</p>}
    </div>
  );
};

export default FlamesGame;
